/* global axios */
import ApiClient from './ApiClient';

class ConversationAiAgentAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(`${this.url}/${conversationId}/ai_agent`);
  }

  update(conversationId, data) {
    return axios.put(`${this.url}/${conversationId}/ai_agent`, {
      ai_agent: data,
    });
  }

  reportFeedback(conversationId, data) {
    return axios.post(`${this.url}/${conversationId}/ai_agent_feedback`, {
      ai_agent_feedback: data,
    });
  }

  // IA-9: resumo da conversa sob demanda (reusa o ConversationSummaryService).
  summary(conversationId) {
    return axios.get(`${this.url}/${conversationId}/ai_agent/summary`);
  }
}

export default new ConversationAiAgentAPI();
